import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";

const DynamicBreadcrumb = ({ fontSize, jobTitle }) => {
    const location = useLocation();

    // Full pathname (with home/jobs intact for routing)
    const fullPathnames = location.pathname.split("/").filter(Boolean);

    // For display, hide "home" and "jobs"
    const breadcrumbSegments = fullPathnames.filter(
        (segment) => segment !== "home" && segment !== "jobs" && segment !== "job-created"
    );

    const formatLabel = (str) => {
        if (!isNaN(str)) return jobTitle || "View Job";
        return str.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    };

    return (
        <div style={{ padding: "0.5rem 0" }}>
            <Breadcrumb separator=">">
                {breadcrumbSegments.map((value, index) => {
                    // ✅ Use full path including home/jobs for correct links
                    const pathIndex = fullPathnames.indexOf(value);
                    const fullPath = "/" + fullPathnames.slice(0, pathIndex + 1).join("/");

                    const isLast = index === breadcrumbSegments.length - 1;

                    return (
                        <Breadcrumb.Item key={fullPath}>
                            {isLast ? (
                                <span
                                    style={{
                                        fontWeight: 600,
                                        color: "#111827",
                                        textTransform: "capitalize",
                                        fontSize: fontSize || "0.95rem",
                                    }}
                                >
                  {formatLabel(value)}
                </span>
                            ) : (
                                <Link
                                    to={fullPath}
                                    style={{
                                        color: "#08839b",
                                        fontWeight: 500,
                                        textTransform: "capitalize",
                                        textDecoration: "none",
                                        fontSize: fontSize || "0.95rem",
                                    }}
                                >
                                    {formatLabel(value)}
                                </Link>
                            )}
                        </Breadcrumb.Item>
                    );
                })}
            </Breadcrumb>
        </div>
    );
};

export default DynamicBreadcrumb;
